<!-- 显示申请单 -->
<template>
  <div class="app-container">
    <Table
      ref="tableRef"
      :showSearchIcon="true"
      :isSelect="true"
      :data="tableData"
      :columns="columns"
      :total="total"
      :loading="loading"
      :searchAttrName="searchAttrName"
      rowKey="applicationFormId"
      :isExpand="true"
      :childColumns="childColumns"
      tableName="applicationRecord"
      exportDataUrl="/applicationForm/selectApplicationForm"
      @expandOpen="handleExpandOpen"
      @onSearch="handleSearch"
    >
    </Table>
  </div>
</template>

<script setup>
import Table from "@/components/Element/Table";
import { onActivated, ref } from "vue";
import { getCustomTableCols } from "@/tableColumn";
import {
  listApplicationForm,
  deleteApplicationForm,
} from "@/api/warehouse/applicationForm";
import { selectProductRecordsByApplicationFormId } from "@/api/warehouse/outInWarehouse";
import { isNull } from "@/utils/fangerUtils";
import { confirmBoxFun } from "@/utils/msgBox";
import useApplicationFormStore from "@/store/modules/applicationForm";
import { useRouter } from "vue-router";

import useCacheStore from "@/store/modules/cache";
const cacheStore = useCacheStore();
const { getProductById } = cacheStore;
const applicationFormStore = useApplicationFormStore();

const router = useRouter();

/**仅支持 Vue 3.3+  配置name 为了是 keep-alive :include 生效 */
defineOptions({
  name: "applicationRecord",
});

const tableRef = ref(null);
const tableData = ref([]);
const total = ref(0);
const loading = ref(false);
const searchAttrName = [];

const handleSearch = (data) => {
  loading.value = true;
  listApplicationForm(data)
    .then((res) => {
      tableData.value = res.data;
      total.value = res?.pageParam?.totleInfo ? res.pageParam.totleInfo : 0;
    })
    .catch(() => {})
    .finally(() => {
      loading.value = false;
    });
};

// 查询展开数据
const handleExpandOpen = (row) => {
  if (!isNull(row.childTableData)) return;
  row.childTableLoading = true;
  selectProductRecordsByApplicationFormId(row.applicationFormId)
    .then((res) => {
      const childTableData = [];
      res.data.forEach((item) => {
        childTableData.push({
          ...getProductById(item.productId),
          ...item,
        });
      });
      row.childTableData = childTableData;
    })
    .catch(() => {})
    .finally(() => {
      row.childTableLoading = false;
    });
};

// 修改
const handleUpdate = (event, row) => {
  applicationFormStore.updateData = row;
  router.push("/applicationForm/updateApplication");
};

// 删除
const handleDelete = (event, row) => {
  confirmBoxFun(() => {
    deleteApplicationForm(row.applicationFormId)
      .then((res) => {
        tableRef.value.onSearch();
      })
      .catch(() => {});
  }, "是否确定要删除此申请单？");
};
// 修改是否可用的判断函数
const handleControlUpdateDisabled = (row) => {
  // 已经审批的不能修改
  return row.approvalStatus !== "0";
};
// 删除是否可用的判断函数
const handleControlDeleteDisabled = (row) => {
  // 已经完成的不能删除
  return row.status !== "0";
};

onActivated(() => {
  // 修改成功后表格触发重新搜索
  if (applicationFormStore.updateSuccessFlag) {
    applicationFormStore.updateSuccessFlag = false;
    tableRef.value && tableRef.value.onSearch();
  }
});

const columns = getCustomTableCols([
  "name",
  "applicant",
  "applicationTime",
  "applicationFormType",
  "applicationFormStatus",
  "outInStatus",
  "inWarehouse",
  "outWarehouse",
  "approvalStatus",
  "rejectRemarks",
  "approver",
  "approvalTime",
  {
    label: "操作",
    prop: "action",
    type: "action",
    search: false,
    action: [
      {
        control: "button",
        controlName: "修改",
        controlType: "success",
        controlText: true,
        controlPermission: ["applicationForm::applicationRecord:update"],
        controlDisabled: handleControlUpdateDisabled,
        controlFun: handleUpdate,
      },
      {
        control: "button",
        controlName: "删除",
        controlType: "danger",
        controlText: true,
        controlPermission: ["applicationForm::applicationRecord:delete"],
        controlDisabled: handleControlDeleteDisabled,
        controlFun: handleDelete,
      },
    ],
  },
]);

const childColumns = getCustomTableCols([
  "productName",
  "productNum",
  "productType",
  "supplierp",
  "supplierModel",
  "internalModel",
  "usageType",
]);
</script>

<style lang="scss" scoped></style>
